import styled from 'styled-components';
import { Spacing40 } from 'autogen/design-tokens/tokens';
import type { ProductReviewListModel } from 'autogen/swagger/all';
import { breakpoint, sizes } from 'variables';
import NoReviews from './components/NoReview';
import ReviewComplianceQuickview from './components/ReviewComplianceQuickview';
import { RatingOverview } from './components/ratingOverview';
import ReviewList from './components/reviewList';

const Wrapper = styled.div`
    display: flex;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${breakpoint.up(sizes.lg)} {
        flex-direction: row;
        align-items: flex-start;
        position: relative;
    }
`;

const RatingOverviewStyled = styled(RatingOverview)`
    ${breakpoint.up(sizes.lg)} {
        flex: 1 1 40%;
        max-width: 440px;
        position: sticky;
        top: ${Spacing40};
    }
`;

const ReviewListStyled = styled(ReviewList)`
    ${breakpoint.up(sizes.lg)} {
        padding-left: ${Spacing40};
        flex: 1 1 60%;
    }
`;

const NoReviewsStyled = styled(NoReviews)`
    flex: 1 1 auto;
`;

export interface IReviewsProps {
    model: ProductReviewListModel;
}

export const Reviews = (props: IReviewsProps): JSX.Element => {
    const { model } = props;

    const noReviews = model.productReviews.length === 0;

    return (
        <>
            <Wrapper id="anchorReviews">
                {noReviews ? (
                    <NoReviewsStyled model={model} />
                ) : (
                    <Container>
                        <RatingOverviewStyled model={model} />
                        <ReviewListStyled model={model} />
                    </Container>
                )}
            </Wrapper>

            {/* QUICKVIEW */}
            <ReviewComplianceQuickview complianceText={model.complianceDescription} />
        </>
    );
};

export default Reviews;
